import {css} from '../../theme/css'
import {cssTheme} from '../theme'

export const fullWidth = css`
  width: 100%;
  width: -moz-available;
  width: -webkit-fill-available;
`

export const linkButton = css`
  color: ${cssTheme.default.day.controlText} !important;
`

// Хексы - cssTheme.default.day.error, на который наложили 5% и 10% черного цвета соответственно. Когда пытаюсь делать это программно - стили ломаются, делаю сейчас так чтобы закрыть до отпуска
// TODO - сделать нормально
export const error = css`
  ${cssTheme.default.day.controlMinorText.token}: ${cssTheme.default.day.textInvert};
  ${cssTheme.components.buttons.ghost.bgColor.token}: ${cssTheme.default.day.error};
  ${cssTheme.components.buttons.ghost.bgColorHovered.token}: #ed3a29;
  ${cssTheme.components.buttons.ghost.bgColorPressed.token}: #e13727
`
